module.exports = __webpack_public_path__ + "img/are-you-ready-mobile.2aab98c0.jpg";